import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
import { FadeIn } from './FadeIn';
const yesItems = ['Sos herrero independiente o dueño de taller', 'Querés dejar de presupuestar a ojo y trabajar con sistema', 'La inflación te comió más de un presupuesto', 'Querés saber cuánto ganás en cada trabajo antes de empezarlo', 'Tenés ayudante y querés que trabaje más autónomo'];
const noItems = ['Buscás un curso teórico de soldadura desde cero absoluto', 'No te interesa documentar ni sistematizar tu trabajo', 'Querés un software CAD para diseñar planos custom'];
export function IsForYou() {
  return <section className="py-12 bg-background border-t border-white/5" aria-label="¿Es para vos?" data-id="element-148">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-149">
        <FadeIn data-id="element-150">
          <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-8" data-id="element-151">
            ¿ESTE MEGAPACK ES PARA <span className="text-gold" data-id="element-152">VOS</span>?
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-153">
          <FadeIn delay={0.1} data-id="element-154">
            <div className="bg-surfaceLight rounded-2xl p-8 border border-emerald-500/20 h-full" data-id="element-155">
              <div className="flex items-center gap-3 mb-6" data-id="element-156">
                <span className="text-2xl" data-id="element-157">✅</span>
                <h3 className="text-xl font-bold text-emerald-400" data-id="element-158">
                  Este sistema es para vos si...
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-159">
                {yesItems.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-160">
                    <CheckCircle2 className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" data-id="element-161" />
                    <span className="text-gray-200" data-id="element-162">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-163">
            <div className="bg-surfaceLight rounded-2xl p-8 border border-red-500/20 h-full" data-id="element-164">
              <div className="flex items-center gap-3 mb-6" data-id="element-165">
                <span className="text-2xl" data-id="element-166">❌</span>
                <h3 className="text-xl font-bold text-red-400" data-id="element-167">
                  Este sistema NO es para vos si...
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-168">
                {noItems.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-169">
                    <XCircle className="w-5 h-5 text-red-400 shrink-0 mt-0.5" data-id="element-170" />
                    <span className="text-gray-300" data-id="element-171">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}